<script>
    import Image from "./Image.svelte";
    import BlockGlobal from "./BlockGlobal.svelte";
    import {M} from "../../external";

    export let data;
</script>
<Image bind:data={data.left} disable={['has-link', 'fullscreen', 'width']} customName={M.PRODUCT + ' 1'}/>
<Image bind:data={data.right} disable={['has-link', 'fullscreen', 'width']} customName={M.PRODUCT + ' 2'}/>
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>